import { render, staticRenderFns } from "./BusinessSignup.vue?vue&type=template&id=b98baace&scoped=true"
import script from "./BusinessSignup.vue?vue&type=script&lang=js"
export * from "./BusinessSignup.vue?vue&type=script&lang=js"
import style0 from "./BusinessSignup.vue?vue&type=style&index=0&id=b98baace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98baace",
  null
  
)

export default component.exports